export default function (element, data) {
    const hoverClass = data.hoverClass;
    
    element.addEventListener("mouseenter", function (event) {
        element.parentElement.classList.add(hoverClass);
    });
    
    element.addEventListener("mouseleave", function (event) {
        element.parentElement.classList.remove(hoverClass);
    });
}
